import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { toFriendlyDateString } from 'helpers/Formatter';

const StyledReadOnlyRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: ${props => (props.underLine ? `1px solid ${colors.OFF_WHITE}` : 'none')};
  ${media.mobile`
    flex-direction: column;
    border-bottom: none;
    margin-bottom: 0px;
  `};
`;
const StyledReadOnlyItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: ${props => props.textAlign || 'left'};
  color: ${props => props.color || 'black'};
  width: auto;
  border-left: ${props => (props.rowDivider ? `1px solid ${colors.OFF_WHITE}` : 'none')};
  padding-left: ${props => (props.rowDivider ? `12px` : '0px')};
  ${media.mobile`
    margin-bottom: 15px;
    padding: 0px;
    text-align: left;
  `};
`;

const StyledH5 = styled.h5`
  margin: 0px;
`;

const StyledRowItemLabel = styled.div`
  margin-bottom: 5px;
  color: ${colors.FONT_GRAY};
`;

const StyledCardContainer = styled.div`
  border-radius: 12px;
  background-color: white;
  padding: 24px 24px 14px 24px;
  margin-bottom: 32px;
`;

export const ViewPurchaseOrderDetails = ({ purchaseOrder }) => {
  return (
    <StyledCardContainer>
      {purchaseOrder.po_number && (
        <StyledReadOnlyRow underLine>
          <StyledReadOnlyItem>
            <StyledRowItemLabel>
              {getTranslatedString('landlordPortal.purchaseOrders.poNumber')}
            </StyledRowItemLabel>
            <StyledH5>{purchaseOrder.po_number}</StyledH5>
          </StyledReadOnlyItem>
        </StyledReadOnlyRow>
      )}
      <StyledReadOnlyRow underLine>
        <StyledReadOnlyItem>
          <StyledRowItemLabel>
            {getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.requiredDate')}
          </StyledRowItemLabel>
          <StyledH5>{toFriendlyDateString(purchaseOrder.required_date)}</StyledH5>
        </StyledReadOnlyItem>
        <StyledReadOnlyItem textAlign="right">
          <StyledRowItemLabel>
            {getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.property')}
          </StyledRowItemLabel>
          <StyledH5>{purchaseOrder.property_name}</StyledH5>
        </StyledReadOnlyItem>
      </StyledReadOnlyRow>
      <StyledReadOnlyRow underLine={!!purchaseOrder.description}>
        <StyledReadOnlyItem>
          <StyledRowItemLabel>
            {getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.vendor')}
          </StyledRowItemLabel>
          <StyledH5>{purchaseOrder.vendor_name}</StyledH5>
        </StyledReadOnlyItem>
        <StyledReadOnlyItem textAlign="right">
          <StyledRowItemLabel>
            {getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.totalCost')}
          </StyledRowItemLabel>
          <StyledH5>{purchaseOrder.total_cost}</StyledH5>
        </StyledReadOnlyItem>
      </StyledReadOnlyRow>
      {purchaseOrder.description && (
        <StyledReadOnlyRow>
          <StyledReadOnlyItem>
            <StyledRowItemLabel>
              {getTranslatedString('landlordPortal.viewPurchaseOrderDrawer.description')}
            </StyledRowItemLabel>
            <div>{purchaseOrder.description}</div>
          </StyledReadOnlyItem>
        </StyledReadOnlyRow>
      )}
    </StyledCardContainer>
  );
};
